// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs_breadcrumbs__MFire typography_paragraphSmall__o7w9R typography_bodyFont__ybYPk","breadcrumb":"breadcrumbs_breadcrumb__tQ0FR"};